import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "q-ml-auto" }

import { ref, onMounted } from "vue";
import { sessionApiStore } from "@/hooks";
import { getParam, navigateTo, QueryParams, Routes } from "@/router";
import { CardPage, PasswordInput, Typography, TextButton } from "@/components";


/**
 * Displays the reset password page.
 */
const __default__ = {
  name: "ResetPasswordView",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const token = ref("");
const password = ref("");

/**
 * Navigates to the login page.
 */
function handleLogin() {
  navigateTo(Routes.LOGIN_ACCOUNT);
}

/**
 * Attempts to reset a user's password.
 */
function handleReset() {
  sessionApiStore.handlePasswordUpdate(password.value, token.value);
}

/**
 * Loads the password reset token on mount.
 */
onMounted(() => {
  const loadedToken = getParam(QueryParams.ACCOUNT_TOKEN);

  if (!loadedToken) return;

  token.value = String(loadedToken);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(CardPage), null, {
    form: _withCtx(() => [
      _createVNode(_unref(Typography), {
        align: "center",
        variant: "title",
        el: "h1",
        value: "Reset Password"
      }),
      (!_unref(sessionApiStore).passwordSubmitted)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_unref(Typography), {
              b: "2",
              el: "p",
              value: "Please enter a new password."
            }),
            _createVNode(_unref(PasswordInput), {
              modelValue: password.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((password).value = $event)),
              "error-message": _unref(sessionApiStore).passwordErrorMessage
            }, null, 8, ["modelValue", "error-message"])
          ]))
        : (_openBlock(), _createBlock(_unref(Typography), {
            key: 1,
            el: "p",
            value: "Your password has been successfully updated."
          }))
    ]),
    actions: _withCtx(() => [
      (!_unref(sessionApiStore).passwordSubmitted)
        ? (_openBlock(), _createBlock(_unref(TextButton), {
            key: 0,
            color: "primary",
            label: "Update Password",
            disabled: password.value.length === 0,
            loading: _unref(sessionApiStore).loading,
            onClick: handleReset
          }, null, 8, ["disabled", "loading"]))
        : _createCommentVNode("", true),
      _createElementVNode("span", _hoisted_2, [
        _createVNode(_unref(TextButton), {
          text: "",
          small: "",
          label: "Back To Login",
          color: "primary",
          onClick: handleLogin
        })
      ])
    ]),
    _: 1
  }))
}
}

})